import React, { useContext, useMemo, useState } from 'react';
import { TranslationKey } from '../../../../../../types/translation/TranslationKey';
import { t } from '../../../../../../types/translation/Translator';
import Table from '../../../../../components/Table';
import SearchBarWithFilter from '../../../../../../VentoryUI/components/common/SearchBarWithFilter';
import { ProductMasterDataContext } from '../../../../../../context/ProductMasterDataContext';
import { TagRelationContext } from '../../../../../../context/TagRelationContext';
import { CustomFieldContext } from '../../../../../../context/CustomFieldContext';
import { CreateButton } from '../../../../../components/Button';
import { DeleteIconButton } from '../../../../../icons';
import { BinConstraint } from '../../../../../../types/bin_constraints/binConstraint';
import { BinConstraintContext } from '../../../../../../context/BinConstraintContext';
import { StockLocationContext } from '../../../../../../context/StockLocationContext';
import { BinContext } from '../../../../../../context/BinContext';
import { BinConstraintFilter } from '../../../../../../VentoryUI/components/filters/BinConstraintFilter/BinConstraintFilter';
import { BinStatusContext } from '../../../../../../context/BinStatusContext';
import CreateBinConstraintModal from './Modals/CreateBinConstraintModal';
import UpdateBinConstraintModal from './Modals/UpdateBinConstraintModal';
import DeleteBinConstraintModal from './Modals/DeleteBinContraintModal';
import { CompanyContext } from '../../../../../../context/CompanyContext';

interface BinConstraintsOverviewPaneProps {
  pmdId?: string;
}

export default function BinConstraintsOverviewPane({ pmdId }: BinConstraintsOverviewPaneProps) {
  const { productMasterData, productMasterDataLoading } = useContext(ProductMasterDataContext);
  const { stockLocations, setStockLocations } = useContext(StockLocationContext);
  const { bins, setBins } = useContext(BinContext);
  const { tagRelations } = useContext(TagRelationContext);
  const { customFields } = useContext(CustomFieldContext);
  const { binStatuses } = useContext(BinStatusContext);

  const { binConstraints, binConstraintsLoading, setBinConstraints } = useContext(BinConstraintContext);
  const { currentCompany } = useContext(CompanyContext);

  const allItems = useMemo(() => {
    console.log(binConstraints);
    return [...binConstraints.values()].filter(item => !pmdId || item.pmdId === pmdId);
  }, [binConstraints]);

  const [item, setItem] = useState<BinConstraint | undefined>();
  const [items, setItems] = useState<BinConstraint[]>(allItems);

  const [createModalOpen, setCreateModalOpen] = useState<boolean>(false);
  const [updateModalOpen, setUpdateModalOpen] = useState<boolean>(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);

  const headers = [
    {
      key: 'stockLocation',
      name: t(TranslationKey.stockLocation).singular.label,
      text: (item: BinConstraint) => stockLocations.get(binConstraints.get(item.id)?.stockLocationId || '')?.name || '',
    },
    {
      key: 'productName',
      name: t(TranslationKey.productName).singular.label,
      text: (item: BinConstraint) => productMasterData.get(binConstraints.get(item.id)?.pmdId || '')?.productName || '',
    },
    {
      key: 'productNumber',
      name: t(TranslationKey.productNumber).singular.label,
      text: (item: BinConstraint) =>
        productMasterData.get(binConstraints.get(item.id)?.pmdId || '')?.productNumber || '',
    },
    {
      key: 'bin',
      name: t(TranslationKey.bin).singular.label,
      text: (item: BinConstraint) => bins.get(binConstraints.get(item.id)?.binId || '')?.name || '',
    },
    {
      key: 'delete',
      name: '',
      text: (item: BinConstraint) => (
        <DeleteIconButton
          onClick={() => {
            setDeleteModalOpen(true);
            setItem(item);
          }}
        />
      ),
    },
  ];

  const filter = new BinConstraintFilter(
    productMasterData,
    bins,
    stockLocations,
    tagRelations,
    customFields,
    binStatuses,
    currentCompany,
  );

  return (
    <>
      {createModalOpen && (
        <CreateBinConstraintModal open={createModalOpen} setOpen={setCreateModalOpen} pmdId={pmdId} />
      )}
      {updateModalOpen && <UpdateBinConstraintModal open={updateModalOpen} setOpen={setUpdateModalOpen} item={item} />}
      {deleteModalOpen && (
        <DeleteBinConstraintModal open={!!deleteModalOpen} setOpen={setDeleteModalOpen} item={item} />
      )}

      <div className={`${pmdId ? '' : 'content-x'} flex h-full flex-grow flex-col gap-4`}>
        <div className='grid gap-2'>
          <p className='page-title'>{t(TranslationKey.binConstraint).plural.upper}</p>
          <p className='subtitle'>{t(TranslationKey.binConstraintSubtitle).singular.upper}</p>
        </div>
        <div className='flex justify-between gap-4'>
          <SearchBarWithFilter
            loading={binConstraintsLoading || productMasterDataLoading}
            items={allItems}
            setItems={setItems}
            placeholder={t(TranslationKey.binConstraintFilter).singular.label}
            filter={filter}
          />
          <div className='flex'>
            <CreateButton onClick={() => setCreateModalOpen(true)} />
          </div>
        </div>
        <Table
          headers={headers}
          items={items}
          filter={filter}
          loading={binConstraintsLoading || productMasterDataLoading}
          onClick={item => {
            setItem(item);
            setUpdateModalOpen(true);
          }}
        />
      </div>
    </>
  );
}
